// Product description CTA

$("#product-shipping-more-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-shipping").offset().top - 164
   }, 1500);
});

$("#product-description-full-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-features").offset().top - 164
   }, 1500);
});

// Product Description Header

$("#product-info-header-features-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-features").offset().top - 100
   }, 1500);
});

$("#product-info-header-specs-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-specs").offset().top - 100
   }, 1500);
});

$("#product-info-header-shipping-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-shipping").offset().top - 100
   }, 1500);
});

$("#product-info-header-des-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-des").offset().top - 100
   }, 1500);
});

$("#product-info-header-acc-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-acc").offset().top - 100
   }, 1500);
});

$("#product-info-header-warranty-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#product-info-header-warranty").offset().top - 100
   }, 1500);
});

$("#product-info-header-reviews-cta").click(function (){
  $('html, body').animate({
    scrollTop: $("#stamped-main-widget").offset().top - 100
   }, 1500);
});

// Header Contact Click
$("#mobile-dropbtn").click(function (){
   $(this).closest(".dropdown-mobile").find('.dropdown-content').slideToggle('slow');
});

$(document).scroll(function() {
  var position = $(this).scrollTop();
  var height = $('.announcement-bar').height();
  if (position > height) {
    $('.breadcrumbs-container-updated').fadeIn("300");
  } else {
    $('.breadcrumbs-container-updated').fadeOut("300");
  }
})

// Product Page: Back to Top
$("#backtoTop").click(function (){
  $('html, body').animate({
    scrollTop: $("#site-main").offset().top - 200
   }, 1500);
});

// Product Description 

$(".product-section-container:last-of-type .toggle-body").hide(); 
$(".product-section-container:last-of-type .toggle-button").addClass('active');  
// $(".product-section-container:nth-last-of-type(2) .toggle-body").hide(); 
// $(".product-section-container:nth-last-of-type(2) .toggle-button").addClass('active'); 

$(".toggle-bar").click(function(){
    $(this).closest(".product-section-container").find('.toggle-body').slideToggle('slow');
    $(this).closest(".product-section-container").find('.toggle-button').toggleClass('active');   
 });

$(".toggle-bar").click(function(){
    $(this).closest(".product-accessory--container").find('.toggle-body').slideToggle('slow');
    $(this).closest(".product-accessory--container").find('.toggle-button').toggleClass('active');   
 });


// Time control

var Now = new Date(),
  CurrentDay = Now.getDay(),
  OpeningTime = new Date(Now.getFullYear(), Now.getMonth(), Now.getDate(), 7, 00),
  ClosingTime = new Date(Now.getFullYear(), Now.getMonth(), Now.getDate(), 17, 30),
  Open = (Now.getTime() > OpeningTime.getTime() && Now.getTime() < ClosingTime.getTime());

if (CurrentDay !== 6 && CurrentDay !== 0 && Open) {
    $('.openstatus').toggle();
}

// Product Video Pop-up
function videoPop() {
  document.getElementById("product-video-popup").style.display = "grid";
}

function shippingVideoPop() {
  document.getElementById("product-shipping-video-popup").style.display = "grid";
}

function closeVideo() {
  document.getElementById("product-video-popup").style.display = "none";
  document.getElementById("product-shipping-video-popup").style.display = "none";
}
// Product bf Coupon
function bfPop() {
  document.getElementById("bf-popup").style.display = "grid";
}

function closeBf() {
  document.getElementById("bf-popup").style.display = "none";
}


// Cyber Monday Pop-up
function cyberPop() {
  document.getElementById("cyber-popup").style.display = "grid";
}

function closeCyber() {
  document.getElementById("cyber-popup").style.display = "none";
}

// let text06 = document.getElementById('icon-coupon-cyber').innerText;
//   const copyCodeC = async () => {
//     try {
//       await navigator.clipboard.writeText(text06);
//       console.log('Content copied to clipboard');
//     } catch (err) {
//       console.error('Failed to copy: ', err);
//     }
//   }
// Pickup Policy Pop-up
function pickupPop() {
  document.getElementById("pickup-popup").style.display = "grid";
}

function closePickup() {
  document.getElementById("pickup-popup").style.display = "none";
}

// Pickup Policy Pop-up
function showroompickupPop() {
  document.getElementById("showroom-promo-pickup-popup").style.display = "grid";
}

function closeshowroompickupPop() {
  document.getElementById("showroom-promo-pickup-popup").style.display = "none";
}

// career


// career
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  if (scroll >= 10) {
      $(".site-header").addClass("site-sticky--scrolled");
  } else {
      $(".site-header").removeClass("site-sticky--scrolled");
  }
});


// Remove Shop Pay "purchasing power"
document.querySelector("shopify-payment-terms").shadowRoot.append(
  Object.assign(document.createElement("STYLE"),{
                           innerText : `span#prequalBackupCTA {
                                          display:none
                                        }`
  })
)





          document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('toggle-description');
  var desc = document.getElementById('collection-description');

  if (toggle && desc) {
    toggle.addEventListener('click', function () {
      desc.classList.toggle('expanded');
      toggle.textContent = desc.classList.contains('expanded') ? 'See less' : 'See more';
    });
  }
});




  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".announcement-slider-container");
    const slider = document.getElementById("announcement-slider");

    if (container) {
      container.classList.add("is-visible");
    }

    let slides = Array.from(slider.children).filter(slide => {
      return window.getComputedStyle(slide).display !== "none";
    });

    let currentIndex = 0;
    let isTransitioning = false;

    // Clone the first slide and append to end
    const firstClone = slides[0].cloneNode(true);
    firstClone.classList.add("clone");
    slider.appendChild(firstClone);
    slides.push(firstClone); // update slides list

    const totalSlides = slides.length;

    function updateSlider(index, animate = true) {
      slider.style.transition = animate ? 'transform 0.5s ease' : 'none';
      slider.style.transform = `translateX(-${index * 100}%)`;
    }

    function nextSlide() {
      if (isTransitioning) return;
      isTransitioning = true;

      currentIndex++;
      updateSlider(currentIndex);
    }

    function prevSlide() {
      if (isTransitioning) return;
      if (currentIndex === 0) {
        currentIndex = totalSlides - 2;
        updateSlider(currentIndex, false);
      } else {
        currentIndex--;
        updateSlider(currentIndex);
      }
      isTransitioning = true;
    }

    slider.addEventListener("transitionend", () => {
      // If we're on the clone, jump to real first slide
      if (slides[currentIndex]?.classList.contains("clone")) {
        slider.style.transition = "none";
        currentIndex = 0;
        updateSlider(currentIndex, false);
      }
      isTransitioning = false;
    });

    const nextBtn = document.querySelector(".announcement-nav.next");
    const prevBtn = document.querySelector(".announcement-nav.prev");

    if (nextBtn) nextBtn.addEventListener("click", nextSlide);
    if (prevBtn) prevBtn.addEventListener("click", prevSlide);

    setInterval(() => {
      nextSlide();
    }, 8000); // autoplay every 8s
  });